import { render, staticRenderFns } from "./KebijakanPrivasi.vue?vue&type=template&id=39ad6330"
import script from "./KebijakanPrivasi.vue?vue&type=script&lang=js"
export * from "./KebijakanPrivasi.vue?vue&type=script&lang=js"
import style0 from "./KebijakanPrivasi.vue?vue&type=style&index=0&id=39ad6330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports